import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-10 md:py-12 px-4 md:px-8 bg-navy-midnight" data-id="element-180">
      <div className="max-w-3xl mx-auto" data-id="element-181">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-gradient-section border-2 border-gold/30 rounded-3xl p-8 md:p-12 text-center relative box-glow" data-id="element-182">
          <div className="absolute -top-10 left-1/2 -translate-x-1/2 bg-navy-dark rounded-full p-4 border-2 border-gold/30" data-id="element-183">
            <ShieldCheckIcon className="w-12 h-12 text-gold" data-id="element-184" />
          </div>

          <h3 className="mt-6 text-3xl font-headline font-extrabold text-white mb-8" data-id="element-185">
            Garantía Incondicional de 7 Días
          </h3>

          <div className="space-y-6 text-lg font-body" data-id="element-186">
            <p className="text-gold font-headline font-bold text-xl md:text-2xl leading-relaxed" data-id="element-187">
              Si en los próximos 7 días sientes que este sistema no entrega lo
              prometido, te devolvemos el 100% de tu dinero.
            </p>

            <p className="text-body" data-id="element-188">
              Sin preguntas. Sin condiciones. Sin burocracia.
            </p>

            <p className="text-white font-headline font-bold text-xl uppercase tracking-wide pt-4 border-t border-gold-separator/30" data-id="element-189">
              Todo el riesgo es nuestro. Todo el beneficio es tuyo.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}